import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './ArtGallery.css';

/*
 * ==============================================
 * HOW TO EDIT (via Claude chat):
 * ==============================================
 * "Add a painting with url https://... titled 'Sunset'"
 * "Add a sculpture photo"
 * "Add my art piece called '...'"
 */

const artCategories = [
  { key: 'all', label: 'All' },
  { key: 'paintings', label: 'Paintings' },
  { key: 'sculptures', label: 'Sculptures' },
  { key: 'other', label: 'Other Creations' },
];

const artworks = [
  // === ADD ARTWORKS BELOW ===
  // {
  //   id: 1,
  //   src: '/images/art/painting1.jpg',
  //   title: 'Artwork Title',
  //   medium: 'Oil on Canvas',
  //   year: '2024',
  //   category: 'paintings', // 'paintings', 'sculptures', or 'other'
  // },
  // === ADD ARTWORKS ABOVE ===
];

function ArtGallery() {
  const [filter, setFilter] = useState('all');

  const filtered = filter === 'all' ? artworks : artworks.filter((a) => a.category === filter);

  return (
    <section className="art section-padding" id="art">
      <div className="container">
        <motion.div
          className="art__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">Art Gallery</span>
          <h2 className="section-title">
            Paintings, sculptures &<br />
            <span className="text-gradient">creative expressions</span>
          </h2>
        </motion.div>

        {/* Filter Tabs */}
        <motion.div
          className="art__filters"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {artCategories.map((cat) => (
            <button
              key={cat.key}
              className={`art__filter ${filter === cat.key ? 'art__filter--active' : ''}`}
              onClick={() => setFilter(cat.key)}
            >
              {cat.label}
            </button>
          ))}
        </motion.div>

        {filtered.length > 0 ? (
          <AnimatePresence mode="wait">
            <motion.div
              key={filter}
              className="art__grid"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              {filtered.map((art, i) => (
                <motion.div
                  key={art.id}
                  className="art__card"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4, delay: 0.05 * i }}
                  whileHover={{ y: -8, transition: { duration: 0.3 } }}
                >
                  <div className="art__card-image">
                    <img src={art.src} alt={art.title} loading="lazy" />
                  </div>
                  <div className="art__card-info">
                    <h3 className="art__card-title">{art.title}</h3>
                    <div className="art__card-meta">
                      {art.medium && <span>{art.medium}</span>}
                      {art.year && <span>{art.year}</span>}
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </AnimatePresence>
        ) : (
          <motion.div
            className="art__empty"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="art__empty-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 19l7-7 3 3-7 7-3-3z"/>
                <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/>
                <path d="M2 2l7.586 7.586"/>
                <circle cx="11" cy="11" r="2"/>
              </svg>
            </div>
            <h3>No artworks yet</h3>
            <p>Tell Claude to add images of your paintings and sculptures!</p>
          </motion.div>
        )}
      </div>
    </section>
  );
}

export default ArtGallery;
